module.exports = __webpack_public_path__ + "img/ios-glider.e0c865f4.svg";